var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { Image } from '@inter-ikea-kompis/component-image';
/**
 * Product Card Water Sense Image Component.
 */
export default class ProductCardWaterSenseImage extends KompisElement {
    /**
     * Renders a water-senses compliance image.
     */
    render() {
        const imageElement = this.getImageElement();
        return imageElement;
    }
    connectedCallback() {
        this.customElements.define('kompis-image', Image);
        super.connectedCallback();
    }
    /**
     * Returns a kompis-image element or null.
     */
    getImageElement() {
        const complianceTechnicalWaterSense = this.findProductComplianceTechnicalWaterSense();
        const src = this.getImageSrc(complianceTechnicalWaterSense);
        const alt = this.getImageAlt(complianceTechnicalWaterSense);
        if (src) {
            return html `
				<style>
					:host {
						display: flex;
					}

					kompis-image {
						width: ${64 / 16}rem;
						height: auto;
						margin-top: ${8 / 16}rem;
						margin-bottom: ${8 / 16}rem;
					}
				</style>
				<kompis-image .theme="${this.theme}" .alt="${alt}" .src="${src}"></kompis-image>
			`;
        }
        return null;
    }
    /**
     * Returns a image alt text.
     *
     * @param complianceTechnicalWaterSense ...
     * @returns Alt.
     */
    getImageAlt(complianceTechnicalWaterSense) {
        if (complianceTechnicalWaterSense) {
            const { headingText, text } = complianceTechnicalWaterSense;
            return `${headingText} ${text}`;
        }
        return null;
    }
    /**
     * Returns a image src url.
     *
     * @param complianceTechnicalWaterSense ...
     * @returns Src.
     */
    getImageSrc(complianceTechnicalWaterSense) {
        const mediaItem = this.getMediaItem(complianceTechnicalWaterSense);
        return mediaItem?.url ?? null;
    }
    /**
     * Returns a single media item from the complianceTechnical media array.
     *
     * @param complianceTechnicalWaterSense ...
     * @returns IProductComplianceTechnicalMedia.
     */
    getMediaItem(complianceTechnicalWaterSense) {
        const svgMedia = this.findMediaItem(complianceTechnicalWaterSense, '00017');
        const jpegMedia = this.findMediaItem(complianceTechnicalWaterSense, '00001');
        return svgMedia ?? jpegMedia;
    }
    /**
     * Function for finding a media that has a svg fileTypeCode.
     *
     * @param complianceTechnicalWaterSense ...
     * @param fileTypeCode ...
     * @returns IProductComplianceTechnicalMedia.
     */
    findMediaItem(complianceTechnicalWaterSense, fileTypeCode) {
        if (complianceTechnicalWaterSense) {
            const { media } = complianceTechnicalWaterSense;
            return media?.find((item) => item.fileTypeCode === fileTypeCode) ?? null;
        }
        return null;
    }
    /**
     * Returns a compliance technical information that is of type Water Sense.
     *
     * @returns IProductComplianceTechnicalMedia.
     */
    findProductComplianceTechnicalWaterSense() {
        const complianceTechnical = this.product?.content?.complianceTechnical;
        return complianceTechnical?.find(this.isWaterSenseItem) ?? null;
    }
    /**
     * Check if item in complianceTechnical has a headingType WATER_SENSE and media key with value.
     *
     * @param complianceTechnical ...
     * @returns Boolean.
     */
    isWaterSenseItem(complianceTechnical) {
        const hasHeadingType = complianceTechnical.headingType === 'WATER_SENSE';
        const hasMedia = 'media' in complianceTechnical;
        return hasHeadingType && hasMedia;
    }
}
__decorate([
    property({ type: Object, required: true })
], ProductCardWaterSenseImage.prototype, "theme", void 0);
__decorate([
    property({ type: Object, required: true })
], ProductCardWaterSenseImage.prototype, "product", void 0);
//# sourceMappingURL=ProductCardWaterSenseImage.js.map